import { useState, useEffect } from "react";
import { Replay, FileDownload } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Typography,
  MenuItem,
  OutlinedInput,
  Select,
  Button,
  FormControl,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import Header from "../../../../../components/Header";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

function JobApplication() {
  const [jobApplications, setJobApplications] = useState([]);
  const [message, setMessage] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [searchName, setSearchName] = useState("");
  const [baseFilteredApplications, setBaseFilteredApplications] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusTab, setStatusTab] = useState("All");
  const [columnFilterColumn, setColumnFilterColumn] = useState(""); // column name
  const [columnFilterValue, setColumnFilterValue] = useState(""); // value to filter
  const [selectedRows, setSelectedRows] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [pageSize, setPageSize] = useState(100); // number of records per page
  const [currentPage, setCurrentPage] = useState(0);
  const [lastId, setLastId] = useState(null); // last document ID for Firestore cursor
  const [hasMore, setHasMore] = useState(true);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const [selectedSourceFilter, setSelectedSourceFilter] = useState("");
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const navigate = useNavigate();
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  const fixedStatuses = [
    "All",
    "Shortlisted",
    "Selected",
    "Rejected",
    "Onboarding",
  ];

  const getDefaultToDate = () => {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    return today;
  };

  const getDefaultFromDate = () => {
    const from = new Date();
    from.setDate(from.getDate() - 7);
    from.setHours(0, 0, 0, 0);
    return from;
  };

  const [fromDate, setFromDate] = useState(getDefaultFromDate);
  const [toDate, setToDate] = useState(getDefaultToDate);

  const handleUpdateStatus = async (
    ids = selectedRows,
    statusValue = newStatus,
  ) => {
    if (!ids || ids.length === 0) {
      alert("Please select at least one application to update.");
      return;
    }
    if (!statusValue) {
      alert("Please select a status to update.");
      return;
    }
    const data = { ids, status: statusValue };
    console.log("rejected appliaction payload:", data);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/reject_applications`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(data),
        },
      );
      const result = await response.json();
      if (response.ok) {
        setMessage(
          `Status updated to "${statusValue}" for ${ids.length} record(s).`,
        );
        setSelectedRows([]);
        // fetchJobApplications();
        // Optimistically update the UI
        setJobApplications((prev) =>
          prev.map((job) =>
            ids.includes(job.id) ? { ...job, status: statusValue } : job,
          ),
        );
        // Hide message after 3 seconds
        setTimeout(() => {
          setMessage("");
        }, 3000); // 3000ms = 3 seconds
      } else {
        alert(result.message || "Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const fetchJobApplications = async (reset = false) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL_HRM}/job_application?page_size=${pageSize}`;
      if (!reset && lastId) {
        url += `&last_id=${lastId}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const result = await response.json();

      const jobs = result.jobs || [];
      setLastId(result.last_id || null);
      setHasMore(jobs.length === pageSize);

      const sortedJobs = [...jobs].sort(
        (a, b) => new Date(b.create_at) - new Date(a.create_at),
      );

      // Append or reset
      setJobApplications((prev) => {
        const combined = reset ? sortedJobs : [...prev, ...sortedJobs];
        const uniqueJobs = Array.from(
          new Map(combined.map((job) => [job.id, job])).values(),
        );
        const uniqueSortedJobs = uniqueJobs.sort(
          (a, b) => new Date(b.create_at) - new Date(a.create_at),
        );

        // Update filters based on combined data
        const uniqueTitles = [
          ...new Set(
            uniqueSortedJobs.map((job) => job.job_title).filter(Boolean),
          ),
        ];
        const uniqueStatuses = [
          ...new Set(uniqueSortedJobs.map((job) => job.status).filter(Boolean)),
        ];
        const uniqueSources = [
          ...new Set(uniqueSortedJobs.map((job) => job.source).filter(Boolean)),
        ];
        setJobTitleOptions(uniqueTitles);
        setJobStatusOptions(uniqueStatuses);
        setSourceOptions(uniqueSources);
        console.log(uniqueSortedJobs);
        return uniqueSortedJobs;
      });

      // // Update filters options
      // const uniqueTitles = [
      //   ...new Set(jobs.map((job) => job.job_title).filter(Boolean)),
      // ];
      // const uniqueStatuses = [
      //   ...new Set(jobs.map((job) => job.status).filter(Boolean)),
      // ];
      // setJobTitleOptions(uniqueTitles);
      // setJobStatusOptions(uniqueStatuses);
    } catch (error) {
      console.error("Error fetching job applications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobApplications();
  }, []);

  useEffect(() => {
    const filtered = jobApplications.filter((app) => {
      const name = app.name?.toLowerCase() || "";
      const search = searchName.toLowerCase();

      const matchesName = name.includes(search);
      const matchesTitle = selectedJobTitle
        ? app.job_title?.toLowerCase() === selectedJobTitle.toLowerCase()
        : true;

      return matchesName && matchesTitle;
    });

    const sorted = [...filtered].sort((a, b) => {
      const dateA = new Date(a.create_at);
      const dateB = new Date(b.create_at);
      return dateB - dateA;
    });

    // This is now the base filtered list (without status tab applied)
    setBaseFilteredApplications(sorted); // <--- use below step to define this
  }, [selectedStatusFilter, selectedJobTitle, jobApplications]);

  useEffect(() => {
    const filtered =
      statusTab === "All"
        ? baseFilteredApplications
        : baseFilteredApplications.filter(
            (app) =>
              app.status?.trim() === statusTab ||
              app.actual_status?.trim() === statusTab,
          );

    setFilteredApplications(filtered);
  }, [baseFilteredApplications, statusTab]);

  useEffect(() => {}, [jobApplications]);

  useEffect(() => {}, [jobTitleOptions]);
  useEffect(() => {}, [jobStatusOptions]);

  useEffect(() => {
    let filtered = jobApplications;

    // Name filter
    if (searchName) {
      filtered = filtered.filter((app) =>
        app.name?.toLowerCase().includes(searchName.toLowerCase()),
      );
    }

    // Job title filter
    if (selectedJobTitle) {
      filtered = filtered.filter(
        (app) =>
          app.job_title?.toLowerCase() === selectedJobTitle.toLowerCase(),
      );
    }

    // Column-based filter
    if (columnFilterColumn && columnFilterValue) {
      filtered = filtered.filter((app) =>
        app[columnFilterColumn]
          ?.toString()
          .toLowerCase()
          .includes(columnFilterValue.toLowerCase()),
      );
    }

    // Status tab filter
    if (statusTab !== "All") {
      filtered = filtered.filter(
        (app) =>
          app.status?.trim() === statusTab ||
          app.actual_status?.trim() === statusTab,
      );
    }

    // Status filter dropdown
    if (selectedStatusFilter && selectedStatusFilter !== "All") {
      filtered = filtered.filter(
        (app) =>
          app.status?.trim() === selectedStatusFilter ||
          app.actual_status?.trim() === selectedStatusFilter,
      );
    }

    // Source filter dropdown
    if (selectedSourceFilter && selectedSourceFilter !== "All") {
      filtered = filtered.filter(
        (app) => app.source?.trim() === selectedSourceFilter,
      );
    }

    // Created At date filter
    if (fromDate || toDate) {
      filtered = filtered.filter((app) => {
        const rawDate = app.create_at || app.created_at || app.createdAt;
        if (!rawDate) return false;

        const appDate = new Date(rawDate);
        if (isNaN(appDate.getTime())) return false;

        // Ignore time portion
        appDate.setHours(0, 0, 0, 0);

        if (fromDate) {
          const from = new Date(fromDate);
          from.setHours(0, 0, 0, 0);
          if (appDate < from) return false;
        }

        if (toDate) {
          const to = new Date(toDate);
          to.setHours(23, 59, 59, 999);
          if (appDate > to) return false;
        }

        return true;
      });
    }

    // Sort by applied date
    filtered = [...filtered].sort(
      (a, b) => new Date(b.create_at) - new Date(a.create_at),
    );

    setFilteredApplications(filtered);
    setBaseFilteredApplications(filtered); // for tab counts
  }, [
    searchName,
    selectedJobTitle,
    columnFilterColumn,
    columnFilterValue,
    statusTab,
    jobApplications,
    selectedStatusFilter,
    selectedSourceFilter,
    fromDate,
    toDate,
  ]);

  const handleRowSelection = (newSelection) => {
    if (newSelection.length > 0) {
      const selectedId = newSelection[0];
      localStorage.setItem("selectedEmployeeId", selectedId);
      navigate(`/job-details/${selectedId}`);
    }
  };

  // NEW: Tab label with count
  const statusCounts = fixedStatuses.reduce((acc, status) => {
    if (status === "All") {
      acc[status] = baseFilteredApplications.length;
    } else {
      acc[status] = baseFilteredApplications.filter(
        (app) =>
          app.status?.trim() === status || app.actual_status?.trim() === status,
      ).length;
    }
    return acc;
  }, {});

  // const CustomToolbar = () => (
  //   <GridToolbarContainer>
  //     <GridToolbarFilterButton />
  //     <GridToolbarExport />
  //   </GridToolbarContainer>
  // );

  const columns = [
    { field: "name", headerName: "Applicant Name ", flex: 1 },

    { field: "job_title", headerName: "Applied Position", flex: 1 },
    { field: "current_city", headerName: "Current Place", flex: 1 },
    { field: "native_place", headerName: "Native Place", flex: 1 },
    {
      field: "highestQualification",
      headerName: "Highest Qualification",
      flex: 1,
    },
    { field: "status", headerName: "Status", flex: 1 },
    // {
    //   field: "source",
    //   headerName: "Source",
    //   flex: 1,
    //   valueGetter: (params) => params.row.source || "website",
    // },
    {
      field: "create_at",
      headerName: "Applied On",
      flex: 1,
      valueFormatter: (params) => {
        const raw = params.value;
        return raw ? new Date(raw).toLocaleString() : "";
      },
      sortComparator: (v1, v2) => new Date(v1) - new Date(v2),
    },
  ];
  const selectedApplications = filteredApplications.filter((app) =>
    selectedRows.includes(app.id),
  );
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleConfirmReject = () => {
    // Call your API here to update status to "Rejected"
    const ids = selectedApplications.map((app) => app.id);
    handleUpdateStatus(ids, "Rejected");
    handleCloseDialog();
  };

  const handleExportClick = () => {
    if (filteredApplications.length === 0) {
      setSnackbar({
        open: true,
        message: "No records to export.",
        severity: "warning",
      });
      return;
    }
    setSnackbar({
      open: true,
      message: "Preparing your export...",
      severity: "info",
    });

    setTimeout(() => {
      try {
        const headers = [
          "Applicant Name",
          "Email",
          "Mobile Number",
          "Applied Position",
          "Current Place",
          "Native Place",
          "Highest Qualification",
          "Status",
          "Applied On",
        ];

        const csvRows = [];
        csvRows.push(headers.join(","));

        filteredApplications.forEach((app) => {
          const escapeCsv = (val) => {
            if (val === null || val === undefined) return '""';
            const str = String(val);
            if (str.includes(",") || str.includes('"') || str.includes("\n")) {
              return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
          };

          const appliedOn = app.create_at
            ? new Date(app.create_at).toLocaleString()
            : "";

          const row = [
            escapeCsv(app.name),
            escapeCsv(app.email),
            escapeCsv(app.mobile_no),
            escapeCsv(app.job_title),
            escapeCsv(app.current_city),
            escapeCsv(app.native_place),
            escapeCsv(app.highestQualification),
            escapeCsv(app.status),
            escapeCsv(appliedOn),
          ];

          csvRows.push(row.join(","));
        });

        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();

        const formatter = new Intl.DateTimeFormat("en-CA", {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, // 24-hour format
        });

        const parts = Object.fromEntries(
          formatter.formatToParts(now).map(({ type, value }) => [type, value]),
        );

        const timestamp = `${parts.year}-${parts.month}-${parts.day}_${parts.hour}-${parts.minute}-${parts.second}`;

        link.setAttribute(
          "download",
          `job_applications_export_${timestamp}.csv`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setSnackbar({
          open: true,
          message: `Exported ${filteredApplications.length} applications successfully.`,
          severity: "success",
        });
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Failed to export CSV.",
          severity: "error",
        });
      }
    }, 500);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ justifyContent: "flex-end", mb: 1, gap: 2 }}>
      {selectedRows.length > 0 && (
        <Box display="flex" alignItems="center" gap={1}>
          {/* <Typography>{selectedRows.length} selected</Typography> */}
          <Button
            variant="contained"
            color="error"
            sx={{ textTransform: "none" }}
            onClick={handleOpenDialog}
          >
            Reject Applications ({selectedRows.length})
          </Button>
        </Box>
      )}
      <Button
        variant="contained"
        startIcon={<FileDownload />}
        onClick={handleExportClick}
        disabled={filteredApplications.length === 0}
        sx={{
          textTransform: "none",
          backgroundColor: colors.blueAccent[700],
          color: theme.palette.mode === "dark" ? colors.grey[100] : "white",
          "&:hover": {
            backgroundColor: colors.blueAccent[800],
          },
        }}
      >
        Export
      </Button>
    </GridToolbarContainer>
  );
  return (
    <Box m="20px">
      <Header title="Job Application" subtitle="List of job" />
      {message && (
        <Typography variant="body1" sx={{ color: "green" }}>
          {message}
        </Typography>
      )}

      <Box
        display="flex"
        gap={3}
        flexWrap="wrap"
        alignItems="flex-start"
        mb={2}
      >
        {/* Search by name */}
        {/* <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          <InputLabel
            shrink
            htmlFor="search-by-name"
            sx={{
              color: "text.primary",
              fontWeight: "bold",
              fontSize: "20px",
              transform: "translate(14px, -9px) scale(0.75)",
              transformOrigin: "top left",
              "&.Mui-focused": {
                color: "text.primary",
              },
            }}
          >
            Search by Name
          </InputLabel>

          <OutlinedInput
            id="search-by-name"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder="Enter..."
            notched
            label="Search by Name"
            sx={{
              borderRadius: "8px",
              backgroundColor: "transparent",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
            }}
          />
        </FormControl> */}

        {/* Filter by job title */}
        <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          <Select
            id="job-title-filter"
            value={selectedJobTitle}
            onChange={(e) => setSelectedJobTitle(e.target.value)}
            displayEmpty
            sx={{
              borderRadius: "8px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "& .MuiSvgIcon-root": { color: "#666" },
            }}
            inputProps={{ shrink: true }}
          >
            <MenuItem value="">All Positions</MenuItem>
            {jobTitleOptions.map((title) => (
              <MenuItem key={title} value={title}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Filter by job status */}
        <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          <Select
            id="status-filter"
            value={selectedStatusFilter}
            onChange={(e) => setSelectedStatusFilter(e.target.value)}
            displayEmpty
            sx={{
              borderRadius: "8px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "& .MuiSvgIcon-root": { color: "#666" },
            }}
            inputProps={{ shrink: true }}
          >
            <MenuItem disabled value="">
              Select Status
            </MenuItem>
            {jobStatusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Filter by source */}
        <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          <Select
            id="source-filter"
            value={selectedSourceFilter}
            onChange={(e) => setSelectedSourceFilter(e.target.value)}
            displayEmpty
            sx={{
              borderRadius: "8px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "& .MuiSvgIcon-root": { color: "#666" },
            }}
            inputProps={{ shrink: true }}
          >
            <MenuItem value="">All Sources</MenuItem>
            {sourceOptions.map((source) => (
              <MenuItem key={source} value={source}>
                {source}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Filter by Created At Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            display="flex"
            gap={2}
            mt={2}
            mb={2}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              borderRadius: "8px",
              px: 2,
              mt: 2,
            }}
          >
            <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
              Applied On:
            </Typography>
            <DatePicker
              value={fromDate}
              onChange={(newValue) => setFromDate(newValue)}
              slotProps={{
                actionBar: { actions: ["clear"] },
                textField: {
                  placeholder: "From Date",
                  sx: {
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "gray !important",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        color:
                          theme.palette.mode === "dark"
                            ? colors.grey[100]
                            : "inherit",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                    },
                  },
                },
              }}
            />
            <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
              -
            </Typography>

            <DatePicker
              value={toDate}
              onChange={(newValue) => setToDate(newValue)}
              minDate={fromDate}
              slotProps={{
                actionBar: { actions: ["clear"] },
                textField: {
                  placeholder: "To Date",
                  sx: {
                    width: 200,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "gray !important",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        color:
                          theme.palette.mode === "dark"
                            ? colors.grey[100]
                            : "inherit",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid gray !important",
                        },
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid gray !important",
                      },
                    },
                  },
                },
              }}
            />
          </Box>
        </LocalizationProvider>

        {/* Column-based filter */}
        <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          {/* <InputLabel id="column-filter-column-label">Filter Column</InputLabel> */}
          <Select
            id="column-filter-column"
            value={columnFilterColumn}
            onChange={(e) => setColumnFilterColumn(e.target.value)}
            displayEmpty
            sx={{
              borderRadius: "8px",
              backgroundColor: "transparent",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
            }}
          >
            <MenuItem disabled value="">
              Select Column
            </MenuItem>
            {columns
              .filter(
                (col) =>
                  col.field !== "create_at" && col.field !== "created_at",
              )
              .map((col) => (
                <MenuItem key={col.field} value={col.field}>
                  {col.headerName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" sx={{ width: 250, mt: 2, mb: 2 }}>
          <OutlinedInput
            placeholder="Enter value"
            value={columnFilterValue}
            onChange={(e) => setColumnFilterValue(e.target.value)}
            sx={{
              borderRadius: "8px",
              backgroundColor: "transparent",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid gray",
              },
            }}
          />
        </FormControl>
        {/* Reset Button */}
        <Button
          variant="outlined"
          startIcon={<Replay />}
          sx={{
            mt: 2,
            mb: 2,
            height: "56px",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 400,
            borderColor: colors.blueAccent[700],
            color: theme.palette.mode === "dark" ? colors.grey[100] : "black",
            backgroundColor: colors.blueAccent[700],
            "&:hover": {
              backgroundColor: colors.blueAccent[700],
              borderColor: colors.blueAccent[700],
            },
          }}
          onClick={() => {
            setSearchName("");
            setSelectedJobTitle("");
            setColumnFilterColumn("");
            setColumnFilterValue("");
            setSelectedStatusFilter("");
            setSelectedSourceFilter("");
            // Reset to default last 7 days
            setFromDate(getDefaultFromDate());
            setToDate(getDefaultToDate());
          }}
        >
          Reset
        </Button>
      </Box>

      <Tabs
        value={statusTab}
        onChange={(e, newValue) => setStatusTab(newValue)}
        variant="fullWidth"
        textColor="inherit"
        indicatorColor="secondary"
        TabIndicatorProps={{
          style: {
            height: "4px",
            backgroundColor: colors.greenAccent[600],
            borderRadius: "2px 2px 0 0",
          },
        }}
        sx={{
          mb: 4,
          backgroundColor: theme.palette.background.default,
          borderRadius: "8px",
          borderBottom: `1px solid ${colors.grey[300]}`,
        }}
      >
        {fixedStatuses.map((status) => (
          <Tab
            key={status}
            label={`${status} (${statusCounts[status] || 0})`}
            value={status}
            sx={{
              textTransform: "none",
              fontWeight: statusTab === status ? "bold" : 800,
              fontSize: "16px",
              color: colors.primary[100],
              mb: 1,
              px: 2,
              "&.Mui-selected": {
                color: colors.greenAccent[600],
                fontWeight: "bold",
              },
              "&:hover": {
                color: colors.greenAccent[400],
              },
            }}
          />
        ))}
      </Tabs>

      <Box
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={loading ? [] : filteredApplications}
          columns={columns}
          components={{ Toolbar: CustomToolbar }}
          checkboxSelection
          autoHeight
          onSelectionModelChange={(selectionModel) =>
            setSelectedRows(selectionModel)
          }
          hideFooterSelectedRowCount
          // onSelectionModelChange={(newSelection) =>
          //   handleRowSelection(newSelection)
          // }
          onRowClick={(params, event) => {
            // prevent navigation if clicking checkbox
            if (event.target.closest(".MuiCheckbox-root")) return;
            const selectedId = params.row.id;
            localStorage.setItem("selectedEmployeeId", selectedId);
            window.open(`/job-details/${selectedId}`, "_blank");
          }}
          getRowId={(row) => row.id}
          loading={loading}
          localeText={{ noRowsLabel: loading ? "Loading..." : "" }}
          sx={{
            "& .MuiDataGrid-cell": {
              cursor: "pointer",
            },
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
            },
            "& .MuiDataGrid-row.Mui-selected": {
              cursor: "pointer",
            },
            "& .MuiCircularProgress-root": {
              color: "white !important",
            },
          }}
          // getRowClassName={(params) =>
          //   params.row.user_want_cancel !== undefined && params.row.user_want_cancel !== null
          //     ? "highlight-row"
          //     : ""
          // }
        />
        {hasMore && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              variant="contained"
              onClick={() => fetchJobApplications(false)}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </Button>
          </Box>
        )}
      </Box>

      {/* Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "18px" }}>
          Reject Selected Applications
        </DialogTitle>
        <DialogContent>
          {selectedApplications.some((app) =>
            ["Onboarding", "Rejected", "Employeed", "NotJoined"].includes(
              app.status,
            ),
          ) && (
            <Typography
              sx={{
                color: "orange",
                mb: 2,
                fontWeight: 500,
              }}
            >
              Warning: Some of the selected applications are already in
              "Employeed", "NotJoined", "Onboarding", or "Rejected" status and
              cannot be rejected. Please unselect those appliactions.
            </Typography>
          )}

          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: theme.palette.background.default,
              boxShadow: "none",
            }}
          >
            <Table
              size="small"
              sx={{ backgroundColor: theme.palette.background.default }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Application ID</TableCell>
                  <TableCell>Old Status</TableCell>
                  <TableCell>New Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedApplications.map((app) => (
                  <TableRow
                    key={app.id}
                    sx={{
                      backgroundColor: [
                        "Onboarding",
                        "Rejected",
                        "Employeed",
                        "NotJoined",
                      ].includes(app.status)
                        ? "rgba(255,165,0,0.2)" // highlight orange-ish
                        : "inherit",
                    }}
                  >
                    <TableCell>{app.id}</TableCell>
                    <TableCell>{app.status || "N/A"}</TableCell>
                    <TableCell>
                      {" "}
                      {[
                        "Employeed",
                        "NotJoined",
                        "Onboarding",
                        "Rejected",
                      ].includes(app.status)
                        ? "" // keep empty
                        : "Rejected"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleCloseDialog}
            sx={{ textTransform: "none" }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmReject}
            color="error"
            variant="contained"
            sx={{ textTransform: "none" }}
            disabled={selectedApplications.some((app) =>
              ["Selected", "Onboarding", "Rejected"].includes(app.status),
            )}
          >
            Confirm Reject
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default JobApplication;
